import React, { useCallback, useContext } from 'react';
import MuroIcon from '@wix/da-ds/pkg/Icons/MuroDraw';
import { isExtensionInstalled } from '../../utils/tiptap';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { openMuro } from '../../../redux/actions/editor';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import EditorIconButton from '../_partials/EditorIconButton';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
const Muro = ({ editor, hideWhenNotEnabled = true })=>{
    const { t } = useTranslation('editor');
    const dispatch = useDispatch();
    const isMuroExp = useFlag('muro_exp');
    const isMobile = useContext(MobileContext);
    const onOpenMuro = useCallback(()=>{
        dispatch(openMuro({
            initialPrompt: ''
        }));
    }, [
        dispatch
    ]);
    if (!editor.isEditable || hideWhenNotEnabled && !isExtensionInstalled(editor, 'muro') || !isMuroExp || isMobile) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(EditorIconButton, {
        featureId: "node:muro",
        icon: MuroIcon,
        onClick: onOpenMuro,
        tooltipText: t('button.muro.tooltip'),
        "aria-label": t('button.muro.tooltip')
    });
};
Muro.displayName = 'Muro';
export default Muro;

//# sourceMappingURL=Muro.js.map